export default __webpack_public_path__ + "static/media/donegif.5e4b703c.gif";